import { SliceGetter, TypedDispatch } from './store';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type ReduxAction<T = any> = (...args: T[]) => (dispatch: TypedDispatch, getState: SliceGetter) => void;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type ReduxFetchAction<T = any> = (...args: T[]) => (dispatch: TypedDispatch, getState: SliceGetter) => Promise<void>;

interface AsyncReduxProperties {
    isLoading: boolean;
    hasFetched: boolean;
    isSuccessful: boolean;
    error: string;
}

export type AsyncReduxState<T = unknown> = Readonly<{
    [P in keyof T]: T[P];
} & AsyncReduxProperties>;

export const initialAsyncReduxState: AsyncReduxState = {
    isLoading: false,
    hasFetched: false,
    isSuccessful: false,
    error: '',
};
